import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14cc6c76")

_pushScopeId("data-v-14cc6c76")
const _hoisted_1 = { class: "text text--primary-gradient text--bold text--size-32 text--less-gap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("a", {
    class: "home flex flex--valign-c flex--gap-20",
    href: _ctx.route('main')
  }, [
    _createVNode("span", {
      class: ["job-fox-logo", { small: _ctx.logoSmall }]
    }, [
      _createVNode(_component_Icon, { identifier: 'djf_update_logo' })
    ], 2),
    _createVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$trans("navigation.nav_title")) + " ", 1),
      (_ctx.extraTitle)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createTextVNode("- " + _toDisplayString(_ctx.extraTitle), 1)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 8, ["href"]))
})